// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-components/build/generate-icons

import { targetCrosshairs16X16 } from '@ni/nimble-tokens/dist/icons/js';
import { Icon, registerIcon } from '../icon-base';

declare global {
    interface HTMLElementTagNameMap {
        'nimble-icon-target-crosshairs': IconTargetCrosshairs;
    }
}

/**
 * The icon component for the 'targetCrosshairs' icon
 */
export class IconTargetCrosshairs extends Icon {
    public constructor() {
        super(targetCrosshairs16X16);
    }
}

registerIcon('icon-target-crosshairs', IconTargetCrosshairs);
export const iconTargetCrosshairsTag = 'nimble-icon-target-crosshairs';
